import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse'

// Import our scoped Tailwind CSS
import './styles/app.css'

// Register plugins before Alpine starts
Alpine.plugin(focus)
Alpine.plugin(collapse)

// Create isolated namespace
window.ResumeAI = window.ResumeAI || {}
window.ResumeAI.Alpine = Alpine

// Store original Alpine.start to prevent global initialization
const originalStart = Alpine.start.bind(Alpine)

// Override Alpine.start to control initialization
Alpine.start = function() {
  // Do nothing - we'll initialize manually
}

// Custom initialization function that only initializes within our containers
window.ResumeAI.initAlpine = function(containerSelector = '.resume-ai-container') {
  const containers = document.querySelectorAll(containerSelector)
  
  containers.forEach(container => {
    // Check if container has already been initialized
    if (!container._x_dataStack) {
      Alpine.initTree(container)
    }
  })
}

// Auto-initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.ResumeAI.initAlpine()
  })
} else {
  // DOM is already loaded
  window.ResumeAI.initAlpine()
}

// Prevent Alpine from being registered globally
delete window.Alpine

// Export for potential future use
export default Alpine